import React from 'react';
import {Table} from 'semantic-ui-react';
import Currency from "../../components/formatters/currency";

export default class TriggersTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            frequencyText: "Yearly"
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.commodityName}</Table.Cell>
                <Table.Cell>{this.props.data.period}</Table.Cell>
                <Table.Cell><Currency value={this.props.data.triggerPrice} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.lastTradePrice} /></Table.Cell>
                <Table.Cell><Currency value={this.props.data.lastNightsOfferPrice} /></Table.Cell>
            </Table.Row>
        );
    }

    componentDidMount = () => {
        this.fetchData();
    }

    fetchData = () => {

    }

    componentDidUpdate = () => {

    }
}